/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { Input, ModalHeader, ModalBody, ModalFooter, Button, Select, SelectItem, Divider, Tooltip, User, Listbox, ListboxItem } from '@nextui-org/react';
import { useSelector } from 'react-redux';
import { IconEye, IconEyeOff } from '@tabler/icons-react';
import toast from 'react-hot-toast';
import { Constants, classNames, clone, fromAssets, fromPhotos, getOnlyNumbers } from '../../../utils';
import { IconImageEdit } from '../../../assets/icons';
import { UsersService } from '../../../services';
import CountryFlag from '../../../components/country-flag';

const ModalCreateParent = ({ user, onSuccess, onClose }) => {
  const { civilStatuses, clearStudents, countries, dniTypes, filters, filterBy, form, genders, onChange, onSubmit, phoneCodes, students } = useForm(user);
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => setIsVisible(!isVisible);

  const submit = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) onSuccess();
  }

  const visibilityBtn = (
    <button className="focus:outline-none" type="button" onClick={toggleVisibility}>
      {isVisible ? (
        <IconEyeOff className="w-6 h-6" />
      ) : (
        <IconEye className="w-6 h-6" />
      )}
    </button>
  )

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">{!!user ? 'Editar' : 'Nuevo'}</ModalHeader>
      <ModalBody className="gap-8">
        <div className="flex items-center justify-start">
          <label htmlFor="photo" className="cursor-pointer text-center border-2 border-gray w-16 h-16 rounded-lg flex justify-center items-center self-center overflow-hidden">
            {!!form.photoUrl ? (
              <img className="w-full h-full object-cover" src={form.photoUrl} alt="Foto" />
            ) : (
              <img className="w-12 object-contain opacity-50" src={IconImageEdit} alt="Foto" />
            )}
            <input
              id="photo"
              type="file"
              accept="image/*"
              hidden
              onChange={e => onChange(e.target.files[0], 'photo')}
            />
          </label>

          <div className="flex flex-col ml-4 text-sm">
            <span className="font-medium leading-3">Subir foto de perfil</span>
            <span>(Tipo carnet y fondo gris)</span>
          </div>
        </div>

        <div className="flex flex-col flex-1 gap-4">
          <div className="grid grid-cols-4 gap-4">
            <Input
              label="Nombre"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.name}
              onValueChange={v => onChange(v, 'name')}
            />
            <Input
              label="Apellido"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.lastname}
              onValueChange={v => onChange(v, 'lastname')}
            />
            <Input
              label="DNI/C.I"
              labelPlacement="outside"
              placeholder=" "
              startContent={(
                <Select
                  aria-label="Tipo de documento"
                  variant="flat"
                  classNames={{ trigger: 'border-0 max-w-24' }}
                  disallowEmptySelection={true}
                  selectedKeys={(!!form.document_type_id && !!dniTypes.length) ? [form.document_type_id] : []}
                  onSelectionChange={v => onChange(v.currentKey, 'document_type_id')}
                >
                  {dniTypes.map((item) => (
                    <SelectItem key={item.value} value={item.value}>
                      {item.label}
                    </SelectItem>
                  ))}
                </Select>
              )}
              variant="bordered"
              radius="sm"
              classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
              value={form.document}
              onValueChange={v => onChange(getOnlyNumbers(v), 'document')}
              maxLength={15}
            />
            <Select
              label="Género"
              labelPlacement="outside"
              placeholder=" "
              variant="bordered"
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              disallowEmptySelection={true}
              selectedKeys={(!!form.gender_id && !!genders.length) ? [form.gender_id] : []}
              onSelectionChange={v => onChange(v.currentKey, 'gender_id')}
            >
              {genders.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>
          </div>

          <div className="grid grid-cols-4 gap-4">
            <Input
              label="Teléfono"
              labelPlacement="outside"
              placeholder=" "
              startContent={(
                <Select
                  aria-label="Código de área"
                  variant="flat"
                  classNames={{ trigger: 'border-0 max-w-28 pl-1 pr-0' }}
                  disallowEmptySelection={true}
                  selectedKeys={(!!form.phonecode_id && !!phoneCodes.length) ? [form.phonecode_id] : []}
                  onSelectionChange={v => onChange(v.currentKey, 'phonecode_id')}
                  startContent={<CountryFlag phoneCodeId={form.phonecode_id} phoneCodes={phoneCodes} />}
                >
                  {phoneCodes.map((item) => (
                    <SelectItem
                      key={item.value}
                      value={item.value}
                      startContent={<CountryFlag src={item.url} />}
                      classNames={{ title: 'min-w-48' }}
                    >
                      {item.label}
                    </SelectItem>
                  ))}
                </Select>
              )}
              variant="bordered"
              radius="sm"
              classNames={{ innerWrapper: 'overflow-hidden', inputWrapper: 'pl-0' }}
              value={form.phone}
              onValueChange={v => onChange(getOnlyNumbers(v), 'phone')}
            />
            <Input
              label="Correo electrónico"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.email}
              onValueChange={v => onChange(v, 'email')}
            />
            <Select
              label="País"
              labelPlacement="outside"
              placeholder=" "
              variant="bordered"
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              disallowEmptySelection={true}
              selectedKeys={(!!form.country_id && !!countries.length) ? [form.country_id] : []}
              onSelectionChange={v => onChange(v.currentKey, 'country_id')}
            >
              {countries.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>
            <Input
              label="Fecha de nacimiento"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              type="date"
              value={form.birthdate}
              onValueChange={v => onChange(v, 'birthdate')}
            />
          </div>

          <div className="grid grid-cols-4 gap-4">
            <Select
              label="Estado civil"
              labelPlacement="outside"
              placeholder=" "
              variant="bordered"
              radius="sm"
              classNames={{ label: 'font-semibold' }}
              disallowEmptySelection={true}
              selectedKeys={(!!form.civil_status_id && !!civilStatuses.length) ? [form.civil_status_id] : []}
              onSelectionChange={v => onChange(v.currentKey, 'civil_status_id')}
            >
              {civilStatuses.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </Select>
            <Input
              label="Domicilio"
              labelPlacement="outside"
              className="col-span-3"
              placeholder=" "
              radius="sm"
              variant="bordered"
              value={form.address}
              onValueChange={v => onChange(v, 'address')}
            />
          </div>

          <Divider />

          <div className="grid grid-cols-4 gap-4">
            <div className="relative">
              <Input
                label="Representados"
                labelPlacement="outside"
                variant="bordered"
                radius="sm"
                placeholder=" "
                isClearable
                onClear={clearStudents}
                value={filters.search}
                onValueChange={v => filterBy(v, 'search')}
              />
              <div className={classNames(students.length ? '' : 'hidden', 'w-full border-small px-1 py-2 rounded-small absolute z-30 bg-white shadow-lg')}>
                <Listbox
                  aria-label="Representados"
                  variant="flat"
                  disallowEmptySelection
                  selectionMode="single"
                  selectedKeys={[]}
                  onSelectionChange={v => {
                    onChange(v.currentKey, 'represented');
                    clearStudents();
                  }}
                  classNames={{ base: 'max-h-48 overflow-auto' }}
                >
                  {students.map(item => (
                    <ListboxItem key={item.id}>{item.fullname}</ListboxItem>
                  ))}
                </Listbox>
              </div>
            </div>

            <div className="flex col-span-3 gap-4 flex-wrap items-center">
              {form.represented.map(item => {
                const schoolGrade = item?.school_grade
                  ? `${item?.school_grade?.name}`
                  : null;

                return (
                  <Tooltip content="Eliminar" color="danger">
                    <User
                      avatarProps={{ showFallback: true, radius: 'full', src: item?.photo ? fromPhotos(item.photo) : null }}
                      classNames={{ base: 'cursor-pointer', description: 'text-foreground-500' }}
                      variant="bordered"
                      onClick={() => onChange(item?.id, 'represented')}
                      name={item?.fullname}
                      description={schoolGrade}
                    />
                  </Tooltip>
                )
              })}
            </div>
          </div>

          <Divider />

          <div className="grid grid-cols-4 gap-4">
            <Input
              label="Contraseña"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              type={isVisible ? "text" : "password"}
              value={form.password}
              onValueChange={v => onChange(v, 'password')}
              endContent={visibilityBtn}
            />
            <Input
              label="Confirmar contraseña"
              labelPlacement="outside"
              placeholder=" "
              radius="sm"
              variant="bordered"
              type={isVisible ? "text" : "password"}
              value={form.confirm_password}
              onValueChange={v => onChange(v, 'confirm_password')}
              endContent={visibilityBtn}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        <Button className="bg-green" color="primary" onPress={submit}>Guardar</Button>
      </ModalFooter>
    </>
  )
}

const useForm = (item) => {
  const initialForm = {
    id: null,
    author_id: null,
    photo: {},
    photoUrl: '',
    name: '',
    lastname: '',
    level_id: Constants.USER.LEVELS.PARENT,
    document_type_id: '',
    document: '',
    phonecode_id: '',
    phone: '',
    email: '',
    country_id: '',
    gender_id: '',
    birthdate: '',
    civil_status_id: '',
    address: '',
    represented: [],
    password: '',
    confirm_password: '',
    hasFile: true,
  };

  const initialFilters = {
    search: '',
    level_id: Constants.USER.LEVELS.PROFESSOR,
  };

  const user = useSelector(state => state.user);
  const [form, setForm] = useState(initialForm);
  const [filters, setFilters] = useState(initialFilters);
  const [dniTypes, setDniTypes] = useState([]);
  const [phoneCodes, setPhoneCodes] = useState([]);
  const [genders, setGenders] = useState([]);
  const [civilStatuses, setCivilStatuses] = useState([]);
  const [countries, setCountries] = useState([]);
  const [students, setStudents] = useState([]);

  const debounceTime = 500;
  const debounce = useRef();

  const onChange = (value, target) => {
    if (target === 'photo' && !!value) {
      setForm(s => {
        return { ...s, photoUrl: URL.createObjectURL(value) }
      });
    }

    if (target === 'represented') {
      let items = clone(form.represented);
      const item = items.find(x => x.id === +value);

      if (item) {
        items = items.filter(x => x.id !== item.id);
      } else {
        const newItem = students.find(x => x.id === +value);
        items.push(newItem);
      }

      return setForm(s => {
        return { ...s, [target]: [...items] }
      });
    }

    setForm(s => ({ ...s, [target]: value }));
  }

  const fetchStudents = async (search) => {

    const _filters = {
      search,
      school_id: user.id,
    };

    if (!search) return clearFilter();

    try {
      const response = await UsersService.school.findStudents(_filters);
      setStudents(response.data);

    } catch (error) {
      setStudents([]);
      onError(String(error));
    }
  }

  const onError = (msg) => {
    toast.error(msg);
    return false;
  }

  const isValidForm = () => {
    if (!form.name)
      return onError('Debe indicar el nombre');

    if (!form.lastname)
      return onError('Debe indicar el apellido');

    if (!form.document_type_id)
      return onError('Debe indicar el tipo de documento');

    if (!form.document)
      return onError('Debe indicar el número de cédula');

    if (!form.gender_id)
      return onError('Debe indicar el género');

    if (!form.phonecode_id)
      return onError('Debe indicar el código de área');

    if (!form.phone)
      return onError('Debe indicar el número telefónico');

    if (!form.country_id)
      return onError('Debe indicar la nacionalidad país');

    if (!form.birthdate)
      return onError('Debe indicar la fecha de nacimiento');

    if (!form.civil_status_id)
      return onError('Debe indicar el estado civil');

    if (!form.address)
      return onError('Debe indicar el domicilio');

    if (!form.email)
      return onError('Debe indicar el correo');

    // if (!form.represented.length)
    // 	return onError('Debe indicar al menos un representado');

    if (!form.id && !form.password)
      return onError('Debe indicar la contraseña');

    if (form.password !== form.confirm_password)
      return onError('Las contraseñas no coinciden');

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;

    const isEditing = !!form.id;
    const data = {
      ...form,
      school_id: user.id,
      represented: form.represented.map(x => x.id),
    };

    try {
      isEditing
        ? await UsersService.school.update(data)
        : await UsersService.school.create(data);
      toast.success(`Usuario ${isEditing ? 'actualizado' : 'creado'} correctamente`);
      return true;

    } catch (error) {
      onError(String(error));
      return false;
    }
  }

  const getSelects = async () => {
    const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));

    try {
      const selects = await UsersService.school.getSelects({ user_id: user.id });
      setDniTypes(toSelect(selects.document_types));
      setPhoneCodes(toSelect(selects.phonecodes));
      setCountries(toSelect(selects.countries));
      setGenders(toSelect(selects.genders));
      setCivilStatuses(toSelect(selects.civil_statuses));

    } catch (error) {
      onError(String(error));
      return false;
    }
  }

  const filterBy = (value, target) => {
    setFilters({ ...filters, page: 1, [target]: value });
    if (debounce.current) clearTimeout(debounce.current);
    debounce.current = setTimeout(() => {
      fetchStudents(value);
    }, debounceTime);
  }

  const clearFilter = () => {
    setStudents([]);
    setFilters({ search: '' });
  }

  useEffect(() => {
    getSelects();

    if (!!item) setForm({
      ...form,
      id: item?.id,
      photoUrl: !!item?.photo ? fromPhotos(item.photo) : '',
      name: item?.name,
      lastname: item?.lastname,
      document_type_id: String(item?.document_type_id || ''),
      document: item?.document,
      phonecode_id: String(item?.phonecode_id || ''),
      phone: item?.phone,
      email: item?.email,
      country_id: String(item?.country_id || ''),
      gender_id: String(item?.country_id || ''),
      birthdate: item?.birthdate,
      civil_status_id: String(item?.country_id || ''),
      address: item?.address,
      represented: item?.represented?.map(x => x.student),
    });
  }, []);

  return {
    civilStatuses,
    clearStudents: clearFilter,
    countries,
    dniTypes,
    filters,
    filterBy,
    form,
    genders,
    onChange,
    onSubmit,
    phoneCodes,
    students,
  }
}

export default ModalCreateParent;
